import { i18n } from "services/i18nService";

import { initialErrorState } from "views/common";

export function isValid(record) {
  const errors = initialErrorState();
  errors.entity = [];

  if (!record.item) {
    errors.messages.push(i18n("serial.Error.Item"));
    errors.entity.push("item");
  }

  if (!record.number || !record.number.trim().length) {
    errors.messages.push(i18n("serial.Error.Number"));
    errors.entity.push("number");
  }
  return errors;
}
